export default __webpack_public_path__ + "static/media/home_tree2.d78ab61f.png";